import React from 'react';
import { Button } from '../shared/Button';
import { CheckIcon } from 'lucide-react';
export const AddOnSection = () => {
  const features = ['Personalized skill evaluation & gap analysis', '5 deep-dive technical sessions', '3 FAANG-style mock interviews', 'Custom technical growth roadmap', 'Language-specific code reviews', 'System design workshops'];
  return <section className="w-full bg-gradient-to-br from-[#1a0d24] to-[#231232] py-24 border-t border-b border-[#6805DA]/20" data-id="element-63">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-64">
        <div className="grid md:grid-cols-2 gap-12 items-center" data-id="element-65">
          <div data-id="element-66">
            <h2 className="text-4xl font-outfit font-bold mb-6 text-white" data-id="element-67">
              1:1 Technical Coaching Add-On
            </h2>
            <p className="text-xl text-gray-300 mb-8" data-id="element-68">
              10 tailored sessions with FAANG engineers. Includes skill
              evaluation, 5 deep dives, 3 mock interviews, and a final technical
              roadmap. Perfect for TPMs or FAANG/quant prep.
            </p>
            <div className="space-y-4 mb-8" data-id="element-69">
              {features.map(feature => <div key={feature} className="flex items-start" data-id="element-70">
                  <CheckIcon size={20} className="text-white/60 mr-3 mt-1 flex-shrink-0" data-id="element-71" />
                  <span className="text-white/80" data-id="element-72">{feature}</span>
                </div>)}
            </div>
            <div className="flex items-center gap-6" data-id="element-73">
              <Button variant="primary" href="/start" data-id="element-74">
                Learn More
              </Button>
            </div>
          </div>
          <div className="bg-white/5 backdrop-blur-sm p-1 rounded-xl border border-white/10" data-id="element-75">
            <div className="bg-[#231232]/90 backdrop-blur-sm rounded-lg p-6" data-id="element-76">
              <h3 className="text-2xl font-outfit font-bold mb-6 text-white" data-id="element-77">
                Technical Assessment Areas
              </h3>
              <div className="space-y-6" data-id="element-78">
                <div data-id="element-79">
                  <h4 className="text-white/80 font-semibold mb-2" data-id="element-80">
                    System Design & Architecture
                  </h4>
                  <div className="w-full bg-white/5 rounded-full h-2" data-id="element-81">
                    <div className="bg-gradient-to-r from-white/20 to-white/10 h-2 rounded-full w-4/5" data-id="element-82" />
                  </div>
                </div>
                <div data-id="element-83">
                  <h4 className="text-white/80 font-semibold mb-2" data-id="element-84">
                    Data Structures & Algorithms
                  </h4>
                  <div className="w-full bg-white/5 rounded-full h-2" data-id="element-85">
                    <div className="bg-gradient-to-r from-white/20 to-white/10 h-2 rounded-full w-3/5" data-id="element-86" />
                  </div>
                </div>
                <div data-id="element-87">
                  <h4 className="text-white/80 font-semibold mb-2" data-id="element-88">
                    Code Quality & Best Practices
                  </h4>
                  <div className="w-full bg-white/5 rounded-full h-2" data-id="element-89">
                    <div className="bg-gradient-to-r from-white/20 to-white/10 h-2 rounded-full w-4/5" data-id="element-90" />
                  </div>
                </div>
                <div data-id="element-91">
                  <h4 className="text-white/80 font-semibold mb-2" data-id="element-92">
                    Technical Communication
                  </h4>
                  <div className="w-full bg-white/5 rounded-full h-2" data-id="element-93">
                    <div className="bg-gradient-to-r from-white/20 to-white/10 h-2 rounded-full w-3/4" data-id="element-94" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
};